import { GET_DEBUG, GET_AGENT_STATE } from '../actions'

const defaults = {
  debug: {
    __typename: 'Debug',
    disconnect: null,
    pingTimeout: false,
    agentStateBeforeDisconnect: null
  }
}

const resolvers = {
  Mutation: {
    setDisconnect: (_, { timestamp }, { cache }) => {
      const { agentState } = cache.readQuery({ query: GET_AGENT_STATE })
      const data = {
        debug: {
          __typename: 'Debug',
          disconnect: timestamp,
          agentStateBeforeDisconnect: agentState
        }
      }
      cache.writeData({ data })
      return null
    },
    setPingTimeout: (_, args, { cache }) => {
      const { debug: oldDebug } = cache.readQuery({ query: GET_DEBUG })
      const data = {
        debug: {
          ...oldDebug,
          pingTimeout: true
        }
      }
      cache.writeData({ data })
      return null
    },
    clearDisconnect: (_, args, { cache }) => {
      const { debug: oldDebug } = cache.readQuery({ query: GET_DEBUG })
      const data = {
        debug: {
          ...oldDebug,
          disconnect: null,
          pingTimeout: false,
          agentStateBeforeDisconnect: null
        }
      }
      cache.writeData({ data })
      return null
    }
  }
}

export default { defaults, resolvers }
